module.exports = __webpack_public_path__ + "static/media/it_was_not_exhibited.654b2f61.png";